import { Component } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
    selector: 'app-confirm',
    templateUrl: './template.html',
    styleUrls: ['./style.scss'],
})
export class ConfirmComponent {
    title = 'Are you sure?';
    content = '';
    confirmText = 'Confirm';
    confirmStatus: 'primary' | 'info' | 'success' | 'warning' | 'danger' | 'control' = 'primary';
    cancelText = 'Cancel';

    constructor(public dialog: NbDialogRef<ConfirmComponent>) {}
}
